export const CASH_REGISTER_REPORT_ENDPOINT = `report/cash_register`;
